import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Phone, Menu, X, Heart } from 'lucide-react';
import { siteConfig } from '../data/mockData';
import { trackPhoneClick } from '../lib/analytics';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Accueil', path: '/' },
    { name: 'Soins infirmiers', path: '/soins' },
    { name: 'À propos', path: '/a-propos' },
    { name: 'Zone d\'intervention', path: '/zone' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-neutral-200">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/logo.png" 
              alt="DK Soins - Infirmière à domicile" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? 'bg-amber-50 text-amber-900'
                    : 'text-neutral-600 hover:bg-neutral-50 hover:text-neutral-900'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center">
            <a href={`tel:${siteConfig.phone}`} onClick={trackPhoneClick}>
              <Button className="bg-amber-600 hover:bg-amber-700 text-white">
                <Phone className="h-4 w-4 mr-2" />
                Appeler
              </Button>
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-md text-neutral-600 hover:bg-neutral-100"
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 space-y-2">
            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium ${
                  isActive(item.path)
                    ? 'bg-amber-50 text-amber-900'
                    : 'text-neutral-600 hover:bg-neutral-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <a href={`tel:${siteConfig.phone}`} onClick={trackPhoneClick} className="block pt-2">
              <Button className="w-full bg-amber-600 hover:bg-amber-700 text-white">
                <Phone className="h-4 w-4 mr-2" />
                Appeler
              </Button>
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}
